module.exports = __webpack_public_path__ + "img/timetable_builder.31e34f27.png";